import { useMutation } from '@apollo/client';
import type {
  InsertTagTypeWithGroupNameMutation,
  InsertTagTypeWithGroupNameMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertTagTypeWithGroupNameDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useInsertTagTypeWithGroupNameTRPC } from './useInsertTagTypeWithGroupNameTRPC';

export const useInsertTagTypeWithGroupName = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  // GraphQL mutation
  const [insertTagTypeGraphQL, graphqlState] = useMutation(
    InsertTagTypeWithGroupNameDocument,
    {
      update: (cache) => {
        evictField(cache, 'tag_type');
      },
    }
  );

  // tRPC mutation
  const trpcMutation = useInsertTagTypeWithGroupNameTRPC();

  const insertTagType = async (
    variables: InsertTagTypeWithGroupNameMutationVariables
  ): Promise<InsertTagTypeWithGroupNameMutation> => {
    if (trpcEnabled) {
      return trpcMutation.insertTagType(variables);
    }

    const result = await insertTagTypeGraphQL({ variables });
    if (!result.data) {
      throw new Error('Failed to insert tag type');
    }

    return result.data;
  };

  return {
    insertTagType,
    loading: trpcEnabled ? trpcMutation.loading : graphqlState.loading,
    error: trpcEnabled ? trpcMutation.error : graphqlState.error,
  };
};
